import { Grid, Typography } from "@mui/material";
import {
  MRT_ColumnDef,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { ParcelCenterZipcode } from "../../../app/models/responseModels/parcelCenterResponse";
import { getDefaultMRTOptions } from "../../dedicatedDelivery/DefaultMrtOptions";

interface AssociatedZipcodeGridProps {
  data: ParcelCenterZipcode[];
}

const AssociatedZipcodeGrid: React.FC<AssociatedZipcodeGridProps> = ({
  data,
}) => {
  const defaultMRTOptions = getDefaultMRTOptions<ParcelCenterZipcode>();

  // Columns to be used on grid on landing page
  const columns = useMemo<MRT_ColumnDef<ParcelCenterZipcode>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
      },
      {
        accessorKey: "zipCode",
        header: "zip Code",
      },
      {
        accessorKey: "createdOn",
        header: "Created On",
        size: 10,
        Cell: ({ cell, row }) => (
          <div>
            {row.original.createdOn ? (
              <span>
                {new Date(cell.getValue<string>()).toLocaleString("en-US", {
                  hourCycle: "h12",
                })}
              </span>
            ) : (
              <span></span>
            )}
          </div>
        ),
      },
      {
        accessorKey: "updatedOn",
        header: "Updated On",
        size: 10,
        Cell: ({ cell, row }) => (
          <div>
            {row.original.createdOn ? (
              <span>
                {new Date(cell.getValue<string>()).toLocaleString("en-US", {
                  hourCycle: "h12",
                })}
              </span>
            ) : (
              <span></span>
            )}
          </div>
        ),
      },
    ],
    [data]
  );

  // preprare MRT V2 grid
  const table = useMaterialReactTable({
    ...defaultMRTOptions,
    columns: columns,
    data: data,
    initialState: {
      ...defaultMRTOptions.initialState,
      columnVisibility: {
        id: true,
      },
      sorting: [{ desc: true, id: "id" }],
    },
    state: {
      showProgressBars: false,
      sorting: [{ desc: true, id: "id" }],
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (e) => {},
      ...defaultMRTOptions.muiTableBodyRowProps,
      sx: {
        cursor: "pointer",
      },
    }),
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderBottomToolbarCustomActions: () => {
      return (
        <Typography variant="subtitle2" component="p">
          Total Rows: {data.length}
        </Typography>
      );
    },
  });

  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <MaterialReactTable table={table} />
    </Grid>
  );
};

export default AssociatedZipcodeGrid;
